export const BG_IMAGES = [
  "/bg-images/img_1030.jpg",
  "/bg-images/img_1709.jpg",
  "/bg-images/img_1719.jpg",
  "/bg-images/img_1781.jpg",
  "/bg-images/img_1847.jpg",
  "/bg-images/img_1862.jpg",
  "/bg-images/img_1863.jpg",
  "/bg-images/img_1891.jpg",
  "/bg-images/img_2368.jpg",
  "/bg-images/img_2479.jpg",
  "/bg-images/img_2505.jpg",
  "/bg-images/img_2912.jpg",
  "/bg-images/img_3695.jpg",
  "/bg-images/img_8613.jpg",
  "/bg-images/img_8659.jpg",
];
